import React, {useMemo} from "react";
import {
    Cell,
    Legend,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip
} from "recharts";
import EmptyData from "../../../../../page-components/common/empty-data/empty-data";
import {FolderOpen} from "lucide-react";
import LoadingSkeleton from "../../../../../page-components/common/loading-skeleton/loading-skeleton";

interface LeaveTypeAnaylsisProps {
    summary: any;
    leaveBalanceLoading: boolean
}

const LeaveTypeAnaylsis = ({summary, leaveBalanceLoading}: LeaveTypeAnaylsisProps) => {

    const PIE_COLORS = [
        '#10b981',
    ];
    const chartData = useMemo(() => {
        if (!summary) return [];

        return Array.from<[string, number]>(summary.entries())
            .map(([key, value]) => ({
                name: key
                    .replaceAll('_', ' ')
                    .toLowerCase()
                    .replace(/\b\w/g, c => c.toUpperCase()),
                value,
            }));
    }, [summary]);

    return (
        <LoadingSkeleton loading={leaveBalanceLoading}>
            <div>
                {
                    summary ?
                        <section>
                            <ResponsiveContainer width="100%" height={200}>
                                <PieChart>
                                    <Pie
                                        data={chartData}
                                        cx="50%"
                                        cy="50%"
                                        innerRadius={55}
                                        outerRadius={80}
                                        paddingAngle={3}
                                        dataKey="value"
                                        nameKey="name"
                                        stroke="none"
                                    >
                                        {chartData.map((_, index) => (
                                            <Cell
                                                key={`cell-${index}`}
                                                fill={PIE_COLORS[index % PIE_COLORS.length]}
                                                stroke="none"
                                            />
                                        ))}
                                    </Pie>

                                    <Tooltip
                                        contentStyle={{
                                            background: '#FFFFFF',
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '8px',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            color: '#0f172a',
                                        }}
                                    />

                                    <Legend
                                        layout="vertical"
                                        verticalAlign="middle"
                                        align="right"
                                        iconType="circle"
                                        iconSize={10}
                                        formatter={(value, entry: any) => {
                                            return (
                                                <span
                                                    style={{
                                                        color: 'var(--pn-text-primary)',
                                                        fontSize: '13px',
                                                        fontWeight: 500,
                                                    }}
                                                >
                {value} : {entry.payload.value}
            </span>
                                            );
                                        }}
                                    />
                                </PieChart>
                            </ResponsiveContainer>
                        </section> :
                        <EmptyData
                            icon={<FolderOpen className={'asset-request-empty-data-icon'}/>}
                            title={"No Asset Requests Found"}
                            subtitle={"There are currently no asset requests to review or manage."}
                        />
                }
            </div>
        </LoadingSkeleton>

    );
};

export default LeaveTypeAnaylsis;